import { F0Box, F0Dialog, F0Text } from '@factorialco/f0-react'
import {
  IncentivesBulkDeleteCompensationPlanMetricDocument,
  IncentivesCompensationPlanDetailDocument,
  IncentivesCompensationPlanDetailMetricsDocument,
} from 'generated/resources/graphql'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import { useMutation } from 'modules/core/hooks/useMutation'
import app from 'modules/core/store/models/app'

interface RemoveMetricDialogProps {
  isOpen: boolean
  onClose: () => void
  metricId: string
}

export function RemoveMetricDialog({ isOpen, onClose, metricId }: RemoveMetricDialogProps) {
  const [deleteMetric, { loading }] = useMutation(
    IncentivesBulkDeleteCompensationPlanMetricDocument,
    {
      extractorFn: (data) => data.incentivesMutations.bulkDeleteIncentivesCompensationPlanMetric,
      refetchQueries: [
        IncentivesCompensationPlanDetailMetricsDocument,
        IncentivesCompensationPlanDetailDocument,
      ],
      awaitRefetchQueries: true,
    }
  )

  const handleConfirm = async () => {
    const result = await deleteMetric({
      variables: { ids: [metricId] },
    })

    const handled = handleResult(result, () =>
      app.setFlash({
        type: 'wrong',
        message: i18n.t('incentives.detail.metrics.remove_metric.error_message'),
      })
    )

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.removed_successfully'),
      })
      onClose()
    }
  }

  return (
    <F0Dialog
      isOpen={isOpen}
      title={i18n.t('incentives.detail.metrics.remove_metric.modal_title')}
      onClose={onClose}
      width="sm"
      primaryAction={{
        label: i18n.t('incentives.detail.metrics.remove_metric.modal_confirm'),
        onClick: handleConfirm,
        loading,
        variant: 'critical',
      }}
      secondaryAction={{
        label: i18n.t('common.cancel'),
        onClick: onClose,
      }}
    >
      <F0Box display="flex" flexDirection="column" gap="md">
        <F0Text content={i18n.t('incentives.detail.metrics.remove_metric.modal_body')} />
      </F0Box>
    </F0Dialog>
  )
}
